import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 text-center text-[color:var(--azsam-ink-soft)]" data-testid="admin-loading">
        Checking your session…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ redirect: "/admin" }} />;
  if (user.role !== "admin") {
    return (
      <div className="max-w-2xl mx-auto py-24 px-6 text-center" data-testid="admin-denied">
        <div className="overline">Administrator only</div>
        <h1 className="mt-4 font-heading text-4xl">You don't have access to this area</h1>
        <p className="mt-4 text-[color:var(--azsam-ink-soft)]">Contact an AzSAM board member if you believe this is an error.</p>
      </div>
    );
  }
  return children;
}
